import { createContext, useReducer } from "react";
import githubReducer from "./GithubReducer";

const GithubContext = createContext();

//Enviorment variables reassigned values
const GITHUB_URL = process.env.REACT_APP_GITHUB_URL;
const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN;

export const GithubProvider = ({children}) => {
    //initial state of data being passed through the context
    const initialState = {
        users: [],
        user: {},
        repos: [],
        loading: false
    }

    //destructured data from reducer
    const [state, dispatch] = useReducer(githubReducer, initialState);

    //Get search results
    const searchUsers = async (text) => {
        setLoading();

        const params = new URLSearchParams({
            q: text
        });

        const response = await fetch(`${GITHUB_URL}/search/users?${params}`, {
            headers: {
                Authorization: `token ${GITHUB_TOKEN}`
            }
        });

        const {items} = await response.json()

        dispatch({
            type: 'GET_USERS',
            payload: items,
        })
    };

    //Get single User result
    const getUser = async (login) => {
        setLoading();

        const response = await fetch(`${GITHUB_URL}/users/${login}`, {
            headers: {
                Authorization: `token ${GITHUB_TOKEN}`
            }
        });

        if (response.status === 404) {
            window.location = '/notfound'
        } else {
            const data = await response.json()

            dispatch({
                type: 'GET_USER',
                payload: data,
            })
        }
    };

       //Get User repos
       const getUserRepos = async (login) => {
        setLoading();

        const params = new URLSearchParams({
            sort: 'created',
            per_page: 10
        });

        const response = await fetch(`${GITHUB_URL}/users/${login}/repos?${params}`, {
            headers: {
                Authorization: `token ${GITHUB_TOKEN}`
            }
        });

        const data = await response.json()

        dispatch({
            type: 'GET_REPOS',
            payload: data,
        })
    };

    //Clear user results from state
    const clearUsers = async () => dispatch({
        type: 'CLEAR_USERS'
    })

    //set Loading
    const setLoading = () => dispatch({type: 'SET_LOADING'})

    //functions and data being passed through context provider
    return (
        <GithubContext.Provider value={{
            users: state.users,
            loading: state.loading,
            user: state.user,
            repos: state.repos,
            searchUsers,
            clearUsers,
            getUser,
            getUserRepos,
        }}>
            {children}
        </GithubContext.Provider>
    )
}

export default GithubContext